import OrderFinished from './OrderFinished';

export default OrderFinished;



// WEBPACK FOOTER //
// ./src/pages/OrderFinished/index.tsx